export default __webpack_public_path__ + "static/char-07-anr-123e95345d10eb58ad443b8ec7463dba.gif";